import { handleActions } from 'redux-actions'
import { quoteEmailData } from './actions'

const initialState = {}

export default handleActions({
  [quoteEmailData]: (state, { payload }) => ({ ...state, ...payload } || initialState)
}, initialState)
